import { useEffect } from 'react';
import Form from '../Meetings/form'

const RegistMeeting = () => {

  useEffect(() => {
    document.title = 'Записаться на встречу | Личный кабинет Брокера THE FIVE';
    
  }, [])

  return (    
    <Form eventTypeId={1} />
  )
}

export default RegistMeeting